import _ from 'underscore';
import kendo from '@bingads-webui/kendo/kendo.data.odata';
import { convertToKendo } from './kendo';

const priorities = {
  and: 1,
  or: 2,
};

// TODO - Task 675798: add odata converter unit test
function kendoToOData(filter) {
  const params = kendo.data.transports.odata.parameterMap({ filter }, 'read');

  // delete filter if its empty
  if (!(_.isString(params.$filter) && params.$filter.length)) {
    delete params.$filter;
  }

  // support [odata v4]
  if (params.$filter && _.isString(params.$filter) && params.$filter.length) {
    // replace substringof by contains
    params.$filter = params.$filter.replace(/substringof\(('.*?'),(tolower\([\w/]+?\))\)/g, 'contains($2, $1)');
    // replace substringof by contains
    params.$filter = params.$filter.replace(/substringof\(('.*?'),([\w/]+?)\)/g, 'contains($2, $1)');
    // replace enum eq formating (with update to handle multiple flags)
    params.$filter = params.$filter.replace(/'Enum\.(\w+)''((\w+,?)+)'''/g, 'Enum.$1\'$2\'');
    // replace datetime'somedate' by somedate
    params.$filter = params.$filter.replace(/datetime'(.*?)'/g, '$1+00:00');
    return params.$filter;
  }
  return '';
}

function customToOData(priorityParent, filter, customOperator) {
  const {
    logic,
    field,
    value,
    operator,
  } = filter;
  const priority = priorities[logic];
  if (priority && _.isArray(filter.filters)) {
    const filterString = _.map(filter.filters, flt => customToOData(priority, flt, customOperator))
      .join(' '.concat(logic, ' '));
    if (_.isNumber(priorityParent) && priority > priorityParent) {
      return '('.concat(filterString, ')');
    }
    return filterString;
  }
  if (_.isFunction(customOperator[field])) {
    return customOperator[field](operator, value);
  }
  if (_.isObject(customOperator[field]) && _.isFunction(customOperator[field][operator])) {
    return customOperator[field][operator](value);
  }
  return kendoToOData({ filters: [filter] });
}

/**
 * Convert filter object to odata formatted.
 * @param {Object} filters - normalized filter object.
 * @param {Object} options - the options object used for odata convertion.
 * @param {Object} [options.fieldMap] - used for kendo convertion.
 * @param {boolean|string[]} [options.ignoreCase] - used for kendo convertion.
 * @param {Object} [options.custom] - custom operator map.
 * @param {Object} filterSchema - filter schema.
 * @returns {Object} - odata formatted filter object.
 */
export function convertToOData(filters, { fieldMap = {}, ignoreCase, custom } = {
  fieldMap: {},
  ignoreCase: false,
}, filterSchema) {
  const kendoFilter = convertToKendo(filters, { fieldMap, ignoreCase }, filterSchema);
  if (!kendoFilter) {
    return '';
  }
  return custom ?
    customToOData(null, _.defaults({ logic: 'and' }, kendoFilter), custom) :
    kendoToOData(kendoFilter);
}
